import { useEffect, useState } from 'react';

const useFontLoader = (fontFamily, isOptionIntersecting = false, size = '16px') => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isOptionIntersecting) {
      return;
    }

    if (document.fonts.check(`${size} "${fontFamily}"`)) {
      setIsLoading(false);
    } else {
      document.fonts.load(`${size} "${fontFamily}"`).then(() => {
        setIsLoading(false);
      });
    }
  }, [fontFamily, isOptionIntersecting, size]);

  return isLoading;
};

export default useFontLoader;
